import React, { useEffect, useRef, useState } from 'react';
import { Form, Button } from 'react-bootstrap'
import { firestore } from "_utils/firebase-app";
import { collection, limit, onSnapshot, orderBy, query, where } from "firebase/firestore";

import { CustomSpinner } from '_components/atoms';

import { useSelector, useDispatch } from "react-redux";
import { resetNewDispatcherMessageStatus, selectEmployeeMessages, selectSelectedForChat, selectSendDispatcherMessageStatus, sendDispatcherMessage, setEmployeeMessages, setEmployeeMessagesToSeen } from '_redux/slices/timeline/employees';
import { selectFirebaseInfo, selectFirebaseUser } from '_redux/slices/main-screen/user';

import { TbChecks } from "react-icons/tb";
import { IoMdSend } from "react-icons/io";
import { formatNameForAvatar } from '_utils/functions';

export const getHoursAndMinutes = (date) => {
    let jsDate;

    if (typeof date === 'string') {
        jsDate = new Date(date);
    } else if (date && 'seconds' in date) {
        jsDate = new Date(date.seconds * 1000 + Math.floor(date.nanoseconds / 1000000));
    } else if (date && '_seconds' in date) {
        jsDate = new Date(date._seconds * 1000 + Math.floor(date._nanoseconds / 1000000));

    } else if (date instanceof Date) {
        jsDate = date;
    } else {
        jsDate = new Date();
    }

    const hour = jsDate.getHours();
    const minute = jsDate.getMinutes();

    return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
};

const Message = ({ msg, emp }) => {
    return <div style={{
        display: 'flex',
        marginBottom: "20px",
        alignItems: 'flex-end',
        justifyContent: msg?.senderId === emp?.employeeId ? 'flex-end' : 'flex-start'
    }}>
        {msg?.senderId !== emp?.employeeId &&
            <div style={{
                border: "1px solid",
                borderRadius: "40px",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                padding: "4px 6px 4px 6px",
                marginInlineEnd: "5px",
            }}>
                <p style={{ margin: 0, width: "fit-content" }}>{formatNameForAvatar(msg?.senderName)}</p>
            </div>
        }
        <div style={{
            maxWidth: '70%',
            padding: 10,
            borderRadius: 16,
            backgroundColor: "lightgray",
            borderBottomRightRadius: msg?.senderId === emp?.employeeId ? 2 : 16,
            borderBottomLeftRadius: msg?.senderId === emp?.employeeId ? 16 : 2,

        }}>
            <p style={{ margin: 0, width: "fit-content" }}>{msg?.text ?? ""} </p>
            <div style={{ display: "flex", alignItems: "center", justifyContent: 'flex-end', gap: 5 }}>
                <p style={{ margin: 0, width: "fit-content" }}>{getHoursAndMinutes(msg?.sentAt ?? "")} </p>
                {msg?.senderId !== emp?.employeeId && <TbChecks color={msg?.status === "seen" ? "green" : "gray"} />}
            </div>
        </div>
        {msg?.senderId === emp?.employeeId &&
            <div style={{
                border: "1px solid",
                borderRadius: "40px",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                padding: "4px 6px 4px 6px",
                marginInlineStart: "5px",
            }}>
                <p style={{ margin: 0, width: "fit-content" }}>{formatNameForAvatar(msg?.senderName)}</p>
            </div>
        }

    </div>
}

const EmployeeChat = () => {

    const messagesEndRef = useRef(null);


    const dispatch = useDispatch();

    const selectedForChat = useSelector(selectSelectedForChat);
    const employeeMessages = useSelector(selectEmployeeMessages);
    const dbUser = useSelector(selectFirebaseInfo);                                       // logged in user
    const firebaseUser = useSelector(selectFirebaseUser);
    const sendDispatcherMessageStatus = useSelector(selectSendDispatcherMessageStatus);


    const [messageText, setMessageText] = useState("");


    useEffect(() => {
        dispatch(resetNewDispatcherMessageStatus());
    }, []);


    useEffect(() => {
        if (sendDispatcherMessageStatus === "succeeded" || sendDispatcherMessageStatus === "failed") {
            dispatch(resetNewDispatcherMessageStatus());

        }

    }, [sendDispatcherMessageStatus])

    useEffect(() => {
        if (selectedForChat?.conversation?._id) {
            const empMessagesCollectionRef = collection(firestore, "employeeMessages");
            const empMessagesQuery = query(
                empMessagesCollectionRef,
                where("conversationId", "==", selectedForChat?.conversation?._id),
                orderBy("sentAt", "desc"),
                limit(50)
            );
            const unsubscribeMessages = onSnapshot(empMessagesQuery, (querySnapshot) => {
                const messages = [];
                querySnapshot.forEach((doc) => {
                    const msgData = doc.data();
                    messages.push(msgData);
                });

                dispatch(setEmployeeMessages(Array.isFullArray(messages) ? messages : []));
                const unSeenMessages = messages?.filter((msg) => msg?.status === "sent" && msg?.senderId == selectedForChat?.employee?.employeeId);
                if (Array.isFullArray(unSeenMessages)) {
                    dispatch(setEmployeeMessagesToSeen({
                        iata: dbUser.details.authority,
                        conversationId: selectedForChat?.conversation?._id ? selectedForChat?.conversation?._id : `${selectedForChat?.employee?.employeeId}_${selectedForChat?.employee?.airport}`
                    }))

                }

                setTimeout(() => {
                    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            });
            return () => unsubscribeMessages();
        }
    }, [selectedForChat?.conversation?._id]);

    // scroll to bottom when messages change
    useEffect(() => {
        if (employeeMessages && employeeMessages.length > 0) {
            setTimeout(() => {
                messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        }
    }, [employeeMessages]);


    const handleSendMessage = async () => {
        const payload = {

            iata: dbUser.details.authority,
            body: {
                conversationId: selectedForChat?.conversation?._id ? selectedForChat?.conversation?._id : `${selectedForChat?.employee?.employeeId}_${selectedForChat?.employee?.airport}`,
                senderId: firebaseUser?.uid,
                senderName: firebaseUser?.displayName,
                text: messageText,
                receiverId: selectedForChat?.employee?.employeeId,
                receiverName: selectedForChat?.employee?.title,
                source: "PORTAL",
                fcmToken: selectedForChat?.employee?.FCMTokens
            }

        };

        const res = await dispatch(sendDispatcherMessage(payload));

        if (res?.meta?.requestStatus === "fulfilled") {
            setMessageText("")
        }

    }

    return (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
            <div style={{ maxHeight: "750px", height: "750px", overflowY: "auto", paddingInline: "30px", display: "flex", flexDirection: "column" }} >
                {employeeMessages?.map((msg) => {
                    if ('type' in msg && msg.type === 'header') {
                        return (
                            <div style={{ display: "flex", alignItems: "center", margin: "0px 20px", justifyContent: "center" }}>
                                <p style={{ margin: 0, width: "fit-content" }}>{msg.date} </p>
                            </div>
                        );
                    }
                    return <Message msg={msg} emp={selectedForChat?.employee} />;
                })}
                <div ref={messagesEndRef} />

            </div>
            <Form.Group className="mt-5 d-flex" style={{ gap: 5 }}>
                <Form.Control as="textarea" rows={3} onChange={(e) => setMessageText(e.target.value)} value={messageText} />
                <Button variant="outline-primary" style={{ height: 40 }} disabled={!messageText} onClick={handleSendMessage}>
                    {sendDispatcherMessageStatus === "loading" ? <CustomSpinner size={"small"} /> : <IoMdSend />}
                </Button>
            </Form.Group>


        </div>
    )
}

export default EmployeeChat
